import { Component, Input, OnInit } from '@angular/core';
import { InstanceResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BaseInstanceResponseDto } from '../models/master-operator-instance';
import { MasterOperatorService } from '../services/master-operator.service';

@Component({
    selector: 'tc-mo-connect-form-instance-option',
    templateUrl: './mo-connect-form-instance-option.component.html',
    styleUrls: ['./mo-connect-form-instance-option.component.scss'],
    standalone: false
})
export class MoConnectFormInstanceOptionComponent implements OnInit {
  @Input() instance: InstanceResponseDto;
  @Input() label: string;
  @Input() containerClass: string = '';
  @Input() hideConnect = false;

  constructor(public masterOperatorService: MasterOperatorService) {}

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.masterOperatorService.instanceReadableLabel(
        this.instance as BaseInstanceResponseDto
      );
    }
  }
}
